import Vue from 'vue';
import Vuep from 'vuep';
import 'vuep/dist/vuep.css';

Vue.use(Vuep);
